import { defineMessages, useIntl } from 'react-intl';
import classNames from 'classnames';
import { type ProductDetailContext } from 'src/client/types/types';

import { useFragmentContext } from '@jsmdg/react-fragment-scripts/fragment';
import {
    ExperienceGuarantee,
    LayoutVariant,
    ShieldCheckBlueIcon,
    ShieldCheckGoldIcon,
} from '@jsmdg/yoshi';
import styles from './ExperienceGuaranteeItem.module.scss';

const messages = defineMessages({
    headline: {
        defaultMessage: 'Immer das richtige Geschenk:',
    },
    headlineMydays: {
        defaultMessage: 'Immer das passende Geschenk:',
    },
    bulletsTitle: {
        defaultMessage: 'Große Auswahl, volle Flexibilität und maximale Sicherheit',
    },
    more: {
        defaultMessage: 'Mehr zur Erlebnis-Garantie erfahren',
    },
    bulletHeadline1: {
        defaultMessage: 'Große Auswahl',
    },
    bulletDescription1: {
        defaultMessage: 'Über 9.000 Erlebnisse.',
    },
    bulletDescription1Mydays: {
        defaultMessage: 'Über 9.000 unvergessliche Erlebnisse.',
    },
    bulletHeadline2: {
        defaultMessage: 'Volle Flexibilität',
    },
    bulletDescription2: {
        defaultMessage: 'Jeder Gutschein für alle Erlebnisse einlösbar.',
    },
    bulletHeadline3: {
        defaultMessage: 'Maximale Sicherheit',
    },
    voucherBenefitValidity: {
        defaultMessage: '{years} Jahre gültig & verlängerbar.',
    },
});

const ExperienceGuaranteeItem = (): JSX.Element => {
    const { isMydays, tenantConfig } = useFragmentContext<ProductDetailContext>();
    const intl = useIntl();

    const bulletIcon = isMydays ? <ShieldCheckGoldIcon /> : <ShieldCheckBlueIcon />;

    const headlineMessage = isMydays ? messages.headlineMydays : messages.headline;
    const bulletDescriptionMessage = isMydays
        ? messages.bulletDescription1Mydays
        : messages.bulletDescription1;

    return (
        <ExperienceGuarantee className="mt-3x" layoutVariant={LayoutVariant.Compact}>
            <ExperienceGuarantee.Headline className={styles.experienceGuaranteeHeadline}>
                {intl.formatMessage(headlineMessage)}
            </ExperienceGuarantee.Headline>
            <div className="pr-5x">
                <ExperienceGuarantee.Bullets
                    collapsible
                    title={intl.formatMessage(messages.bulletsTitle)}
                    className={classNames('pr-0', styles.BulletsTitle)}
                >
                    <ExperienceGuarantee.BulletItem icon={bulletIcon}>
                        <div className="d-flex flex-column">
                            <span className="fw-semibold">
                                {intl.formatMessage(messages.bulletHeadline1)}
                            </span>
                            <span className={styles.bullet}>
                                {intl.formatMessage(bulletDescriptionMessage)}
                            </span>
                        </div>
                    </ExperienceGuarantee.BulletItem>
                    <ExperienceGuarantee.BulletItem icon={bulletIcon}>
                        <div className="d-flex flex-column">
                            <span className="fw-semibold">
                                {intl.formatMessage(messages.bulletHeadline2)}
                            </span>
                            <span className={styles.bullet}>
                                {intl.formatMessage(messages.bulletDescription2)}
                            </span>
                        </div>
                    </ExperienceGuarantee.BulletItem>
                    <ExperienceGuarantee.BulletItem icon={bulletIcon}>
                        <div className="d-flex flex-column">
                            <span className="fw-semibold">
                                {intl.formatMessage(messages.bulletHeadline3)}
                            </span>
                            <span className={styles.bullet}>
                                {intl.formatMessage(messages.voucherBenefitValidity, {
                                    years: tenantConfig.voucherExpirationLimitInYears,
                                })}
                            </span>
                        </div>
                    </ExperienceGuarantee.BulletItem>
                </ExperienceGuarantee.Bullets>
            </div>
        </ExperienceGuarantee>
    );
};

export { ExperienceGuaranteeItem };
